import React from 'react'

const BuilderComponentDeadComp = React.lazy(
	() => import('./BuilderComponentDeadComp' /* webpackChunkName: "BuilderComponentDeadComp" */)
)
const LazyBuilderComponentDeadComp = () => {
	return (
		<React.Suspense fallback={<div />}>
			<BuilderComponentDeadComp />
		</React.Suspense>
	)
}

export default LazyBuilderComponentDeadComp
